import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';

const Share = (props: any) => {
  return <ShareOutlinedIcon {...props} />;
};

export default Share;
